<div class='row'>


  <div class='container-lg mt-4'>

    <div class='row d-flex justify-content-center'>


      <div class='col-12 col-xl-7 col-lg-9 justify-content-end'>

        <div class='row'>
          <div class='col'>
            <app-test-details-card [headerNeeded]='true' [footerNeeded]='false' [apiUid]='selectedItem?.uid.toString()'
                                   [selectedItem]='selectedItem'
                                   [locationEditNeeded]='true' [userSavedWaterSources]='userSavedWaterSources'
                                   [userSavedPlaces]='userSavedPlaces' [idToken]='idToken'
                                   (pdfEvent)='createPdf()' [userEmail]='this.userdata.email'
                                   *ngIf='this.userdata && this.selectedItem'
                                   (updateDataEvent)='getUserSavedData(this.idToken)'></app-test-details-card>
            <hr>
            <div [hidden]='!this.isAdmin && !this.isLabUser && !this.isOrgAdmin'>
              <div class='list-container mb-2'>
                <div>
                  <h3>Graph</h3>
                  <div id='chartDiv' style='width: 100%; height: 500px'></div>
                </div>
              </div>

              <div class='list-container mb-2'>
                <div>
                  <div class='d-flex justify-content-between align-items-start'>
                    <h3>Graph - Stage 1</h3>
                    <button class='btn btn-primary' (click)='downloadStageData(1)'
                            *ngIf='selectedItem?.calculationResult.testType === "legionella" && selectedItem.calculationResult.legionellaStage >= 1 && this.userRole!=="user"'>
                      Download stage 1 data
                    </button>
                  </div>
                  <div id='stage1Div' style='width: 100%; height: 500px'></div>
                </div>
              </div>
              <div class='list-container mb-2'>
                <div class='d-flex justify-content-between align-items-start'>
                  <h3>Graph - Stage 2</h3>
                  <button class='btn btn-primary' (click)='downloadStageData(2)'
                          *ngIf='selectedItem?.calculationResult.testType === "legionella" && selectedItem.calculationResult.legionellaStage >= 2 && this.userRole!=="user"'>
                    Download stage 2 data
                  </button>
                </div>
                <div id='stage2Div' style='width: 100%; height: 500px'></div>
              </div>
              <div class='list-container mb-2'>
                <div class='d-flex justify-content-between align-items-start'>
                  <h3>Graph - Stage 3</h3>
                  <button class='btn btn-primary' (click)='downloadStageData(3)'
                          *ngIf='selectedItem?.calculationResult.testType === "legionella" && selectedItem.calculationResult.legionellaStage === 3 && this.userRole!=="user"'>
                    Download stage 3 data
                  </button>
                </div>
                <div id='stage3Div' style='width: 100%; height: 500px'></div>
              </div>

            </div>
            <div class='list-container mb-1' *ngIf="selectedItem?.calculationResult.testType=='ecoli'"
                 [hidden]='!this.isAdmin'>
              <div class='card-body'>
                <h5>ECOLI INFO</h5>
                <p>Test Complete: {{selectedItem?.calculationResult.ecoliTestComplete}}</p>
                <p
                  *ngIf='selectedItem?.calculationResult.eColiStage1Date'>Stage 1 date: {{selectedItem?.calculationResult.eColiStage1Date.seconds * 1000 | date :'short'}}</p>
                <p
                  *ngIf='selectedItem?.calculationResult.eColiStage2Date'>Stage 2 date: {{selectedItem?.calculationResult.eColiStage2Date.seconds * 1000 | date :'short'}}</p>
                <p
                  *ngIf='selectedItem?.calculationResult.eColiStage3Date'>Stage 3 date: {{selectedItem?.calculationResult.eColiStage3Date.seconds * 1000 | date :'short'}}</p>
              </div>
            </div>
            <div class='list-container mb-1' *ngIf="selectedItem?.calculationResult.testType=='c19'"
                 [hidden]='!this.isAdmin'>
              <div class='card-body'>
                <h5>C19 INFO</h5>
                <p>Test Complete: {{selectedItem?.calculationResult.c19TestComplete}}</p>
                <p
                  *ngIf='selectedItem.calculationResult.c19Stage1Date'>Stage 1 date: {{selectedItem?.calculationResult.c19Stage1Date.seconds * 1000 | date :'short'}}</p>
                <p
                  *ngIf='selectedItem.calculationResult.c19Stage2Date'>Stage 2 date: {{selectedItem?.calculationResult.c19Stage2Date.seconds * 1000 | date :'short'}}</p>
                <p
                  *ngIf='selectedItem.calculationResult.c19Stage3Date'>Stage 3 date: {{selectedItem?.calculationResult.c19Stage3Date.seconds * 1000 | date :'short'}}</p>
              </div>
            </div>
            <div class='list-container' *ngIf='this.userRole!=="user"'>
              <div class='card-body'>
                <h3 class='card-title'>Server Data</h3>
                <p class='card-text'>IP: {{selectedItem?.calculationResult.ip}}  </p>
                <p>Geo: {{selectedItem?.calculationResult.geoip | json}}</p>
                <p class='card-text'>Start Frame: {{selectedItem?.calculationResult.startFrame}}</p>
                <p class='card-text'>End Frame: {{selectedItem?.calculationResult.endFrame}}</p>
                <p class='text-danger'
                   *ngIf='selectedItem?.calculationResult.slope'>R: {{selectedItem?.calculationResult.slope.toFixed(2)}} r2: {{selectedItem.calculationResult.confidence}}</p>
                <p class='text-success'
                   *ngIf='selectedItem?.calculationResult.gSlope'>G: {{selectedItem?.calculationResult.gSlope.toFixed(2)}} r2: {{selectedItem.calculationResult.gConfidence}}</p>
                <p
                  *ngIf='selectedItem?.calculationResult.recalcDate'> {{ selectedItem?.calculationResult.recalcDate}}</p>
                <!-- Must specify "undefined" in case it's 0 -->
                <p
                  *ngIf='selectedItem?.calculationResult.bacteriaLevel !== undefined &&
                  (selectedItem?.calculationResult.testType === "bacteria"||
                  selectedItem?.calculationResult.testType === "bacteria-100"||
                  selectedItem?.calculationResult.testType === "legionella")'>Bacteria Level: {{ selectedItem?.calculationResult.bacteriaLevel}}</p>
                <p
                  *ngIf='selectedItem?.calculationResult.eColiLevel !== undefined && selectedItem?.calculationResult.testType === "ecoli"'>E. Coli Level: {{ selectedItem?.calculationResult.eColiLevel}}</p>
                <p
                  *ngIf='selectedItem?.calculationResult.disinfectantLevel !== undefined'>Disinfectant Level: {{ selectedItem?.calculationResult.disinfectantLevel}}</p>
                <p>
                  <button class='btn btn-primary btn-outline' (click)='recalcTest()'>Recalculate</button>
                </p>

                <p>
                  <button class='btn btn-primary btn-outline' (click)='downloadRawData()'>Download Raw Data</button>
                </p>
              </div>
            </div>


          </div>
        </div>
      </div>
      <div class='col-lg-3 d-lg-block d-none fit-content'>
        <div class='list-container fit-content'>
          <ngx-skeleton-loader count='2' [theme]="{
          'width': '100%'
        }" [hidden]='selectedItem && testLoaded && userSavedPlaces'></ngx-skeleton-loader>
          <div id='profile-container' class='text-center' *ngIf='selectedItem && testLoaded && userSavedPlaces'>

            <h3 class='mb-0'>{{this.testUserData?.data.displayName || "No Display Name"}}</h3>

            <p>{{this.testUserData?.data.email}}</p>
          </div>
          <small>ORGANIZATION</small>
          <ngx-skeleton-loader count='1' [theme]="{
          'width': '100%'
        }" [hidden]='selectedItem && testLoaded && userSavedPlaces'></ngx-skeleton-loader>
          <p>{{this.userOrgData?.name}}</p>
          <button class='btn btn-light w-100' (click)='navigateToUser()'>View Profile</button>
        </div>

        <div id='map-container' class='pr-2 list-container h-25 w-100 mt-3' [hidden]='!loaded'
             *ngIf='selectedItem && testLoaded && userSavedPlaces'>
          <google-map
            height='100%'
            width='95%'
            class='pr-2'
            [zoom]='15'
            [center]='{lat:selectedItem?.location.lat, lng: selectedItem?.location.lng}'>
            <map-marker
                #markerElem='mapMarker'
                [id]='selectedItem?.location.place_id'
                [position]='position'
                [options]='markerOptions'>

            </map-marker>
          </google-map>
        </div>
      </div>
    </div>
  </div>
</div>
